import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinnavimumbai() {



    const cardData = {

keyword: "Swift Dzire on Rent in Navi Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Swift Dzire on Rent in Navi Mumbai for airport transfers, local travel, corporate commuting, family trips, and outstation journeys. We provide well-maintained Maruti Suzuki Swift Dzire sedan cars with comfortable seating, smooth ride quality, air-conditioning, and professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving, we ensure a budget-friendly, comfortable, and hassle-free travel experience for every journey.",

topPlaces: [
    
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, lakes, and cool climate, ideal for family vacations."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal getaway near Mumbai known for clean beaches, forts, and peaceful weekend relaxation."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, and traditional Maharashtrian cuisine, attracting pilgrims and tourists."
    },
    {
        title: "Pune",
        description:
            "Pune is a major IT and educational hub near Navi Mumbai, ideal for business travel, family visits, and affordable sedan journeys like Swift Dzire."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station famous for waterfalls, valleys, caves, and monsoon views, making it perfect for short and comfortable weekend trips."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from all over India throughout the year."
    },
    {
        title: "Nashik",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and religious tourism, making it a popular outstation destination from Navi Mumbai."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, and historical monuments."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan coastal destination known for Ganpatipule Temple, beaches, and scenic highway drives."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s most popular beach destination known for nightlife, beaches, water sports, and long-distance comfortable travel."
    }
],



services: [
{
name: "Swift Dzire On Rent in Mumbai",
description: "Swift Dzire On Rent in Mumbai by 1Touch Cabs offers affordable and comfortable sedan travel for individuals, families, and business travellers. Our well-maintained Swift Dzire vehicles are ideal for city rides, airport transfers, local travel, and outstation journeys. With experienced chauffeurs, clean interiors, air-conditioned comfort, and smooth driving, we ensure a safe and reliable travel experience. Whether it is daily travel, corporate meetings, or long-distance trips, we provide punctual service, transparent pricing, and 24x7 availability across Mumbai."
},
{
name: "Swift Dzire On Rent in Navi Mumbai",
description: "Swift Dzire On Rent in Navi Mumbai service provides budget-friendly and comfortable sedan transportation for local travel, airport pickups, and outstation trips. 1Touch Cabs ensures well-maintained vehicles, professional drivers, and smooth ride experiences for families, tourists, and corporate travellers. With easy booking, reliable service, and affordable pricing, we make every journey convenient and stress-free across Navi Mumbai."
},
{
name: "Swift Dzire Rental Navi Mumbai",
description: "Swift Dzire Rental Navi Mumbai service offers flexible sedan rental options for hourly, daily, and long-distance travel. 1Touch Cabs provides clean and fuel-efficient cars with experienced chauffeurs ensuring safe and comfortable journeys. Ideal for airport transfers, business travel, and family trips, our service guarantees punctuality and affordability."
},
{
name: "Swift Dzire Hire in Navi Mumbai",
description: "Swift Dzire Hire in Navi Mumbai service is designed for customers seeking reliable and economical sedan travel. 1Touch Cabs offers professional chauffeurs, sanitized vehicles, and flexible hire packages for city rides, weddings, airport transfers, and outstation journeys. We focus on comfort, safety, and timely service."
},
{
name: "Swift Dzire Car Rental Navi Mumbai",
description: "Swift Dzire Car Rental Navi Mumbai service provides dependable and comfortable transportation for all travel needs including local trips, intercity travel, and airport transfers. 1Touch Cabs ensures clean vehicles, trained drivers, and transparent pricing for a smooth travel experience."
},
{
name: "Swift Dzire Taxi Service Navi Mumbai",
description: "Swift Dzire Taxi Service Navi Mumbai offers convenient and affordable taxi solutions for daily commuting and long-distance travel. 1Touch Cabs provides experienced chauffeurs, air-conditioned comfort, and reliable service for families, professionals, and tourists across Navi Mumbai."
},
{
name: "Book Swift Dzire on Rent in Navi Mumbai",
description: "Book Swift Dzire on Rent in Navi Mumbai service allows customers to quickly reserve a comfortable sedan for any travel requirement. 1Touch Cabs provides instant booking confirmation, flexible packages, and professional chauffeur service for airport transfers, business trips, and outstation journeys."
},
{
name: "Best Swift Dzire on Rent Navi Mumbai",
description: "Best Swift Dzire on Rent Navi Mumbai by 1Touch Cabs ensures high-quality sedan travel with clean vehicles, experienced drivers, and smooth ride comfort. We prioritize safety, punctuality, and affordability, making it ideal for both personal and professional travel needs."
},
{
name: "Cheapest Swift Dzire Rental Navi Mumbai",
description: "Cheapest Swift Dzire Rental Navi Mumbai service offers economical sedan travel without compromising comfort or safety. 1Touch Cabs provides affordable pricing, reliable chauffeurs, and well-maintained vehicles for budget-friendly city and outstation trips."
},
{
name: "Swift Dzire On Rent with Driver Navi Mumbai",
description: "Swift Dzire On Rent with Driver Navi Mumbai service includes professional chauffeurs ensuring safe and stress-free travel. 1Touch Cabs provides experienced drivers familiar with local and highway routes, making travel smooth, punctual, and comfortable for all passengers."
},
{
name: "Swift Dzire Rental Service Navi Mumbai",
description: "Swift Dzire Rental Service Navi Mumbai offers complete transportation solutions for airport transfers, city rides, and outstation journeys. 1Touch Cabs ensures clean vehicles, flexible rental plans, and reliable service for a hassle-free travel experience."
},
{
name: "Swift Dzire Airport Pickup Navi Mumbai",
description: "Swift Dzire Airport Pickup Navi Mumbai service ensures timely and comfortable pickup from airports with flight tracking and luggage assistance. 1Touch Cabs provides professional chauffeurs and air-conditioned sedans for smooth post-flight travel."
},
{
name: "Swift Dzire Airport Drop Navi Mumbai",
description: "Swift Dzire Airport Drop Navi Mumbai service offers punctual and reliable transportation to domestic and international airports. 1Touch Cabs ensures on-time pickup, safe driving, and stress-free airport arrival for all passengers."
},
{
name: "Swift Dzire Outstation Rental Navi Mumbai",
description: "Swift Dzire Outstation Rental Navi Mumbai service provides affordable and comfortable long-distance travel for family trips, business travel, and weekend getaways. 1Touch Cabs ensures safe highway driving and reliable chauffeur service."
},
{
name: "Swift Dzire Cab for Outstation Navi Mumbai",
description: "Swift Dzire Cab for Outstation Navi Mumbai service is ideal for economical intercity travel with comfort and safety. 1Touch Cabs offers experienced drivers, clean vehicles, and flexible travel plans for smooth long-distance journeys."
},
{
name: "Swift Dzire On Rent in Vashi",
description: "Swift Dzire On Rent in Vashi service provides convenient sedan transportation for local and outstation travel. 1Touch Cabs ensures reliable drivers, clean vehicles, and timely service for residents and business travellers in Vashi."
},
{
name: "Swift Dzire On Rent in Nerul",
description: "Swift Dzire On Rent in Nerul service offers affordable and comfortable taxi solutions for airport transfers, daily commuting, and intercity travel. 1Touch Cabs provides professional chauffeurs and well-maintained sedans."
},
{
name: "Swift Dzire On Rent in Kharghar",
description: "Swift Dzire On Rent in Kharghar service delivers reliable sedan travel for families, professionals, and tourists. 1Touch Cabs ensures smooth rides, punctual service, and affordable pricing for all travel needs."
},
{
name: "Swift Dzire On Rent in Panvel",
description: "Swift Dzire On Rent in Panvel service offers budget-friendly and comfortable transportation for local and long-distance travel. 1Touch Cabs provides experienced drivers and clean vehicles for a safe travel experience."
},
{
name: "Swift Dzire Rental Navi Mumbai (Repeat Variant)",
description: "Swift Dzire Rental Navi Mumbai service provides flexible and economical sedan travel options for airport transfers, business travel, and family trips. 1Touch Cabs ensures reliable service, clean vehicles, and professional chauffeurs for a smooth journey."
}
],

tableData: [
["Swift Dzire On Rent in Mumbai","Swift Dzire On Rent in Navi Mumbai"],
["Swift Dzire Rental Navi Mumbai","Swift Dzire Hire in Navi Mumbai"],
["Swift Dzire Car Rental Navi Mumbai","Swift Dzire Taxi Service Navi Mumbai"],
["Book Swift Dzire on Rent in Navi Mumbai","Best Swift Dzire on Rent Navi Mumbai"],
["Cheapest Swift Dzire Rental Navi Mumbai","Swift Dzire On Rent with Driver Navi Mumbai"],
["Swift Dzire Airport Pickup Navi Mumbai","Swift Dzire Airport Drop Navi Mumbai"],
["Swift Dzire Outstation Rental Navi Mumbai","Swift Dzire Cab for Outstation Navi Mumbai"],
["Swift Dzire On Rent in Vashi","Swift Dzire On Rent in Nerul"],
["Swift Dzire On Rent in Kharghar","Swift Dzire On Rent in Panvel"]
],










whychoose: [
    {
        WhyChooseheading: "Reliable Swift Dzire on Rent in Navi Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Swift Dzire Rental Services in Navi Mumbai for airport transfers, local travel, corporate transportation, family trips, and outstation journeys."
    },
    {
        WhyChooseheading: "Comfortable and Budget-Friendly Sedan",
        WhyChoosedescription: "Maruti Suzuki Swift Dzire is one of the most preferred sedan cars for comfortable travel, offering spacious seating, smooth performance, and economical transportation."
    },
    {
        WhyChooseheading: "Perfect for Local and Outstation Travel",
        WhyChoosedescription: "Whether you need a cab within Navi Mumbai or for destinations like Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Kolhapur, and Goa, Swift Dzire is an excellent travel choice."
    },
    {
        WhyChooseheading: "Ideal for Airport Transfers",
        WhyChoosedescription: "Swift Dzire is a popular option for Mumbai Airport and Navi Mumbai Airport transfers due to its comfort, luggage capacity, and smooth ride quality."
    },
    {
        WhyChooseheading: "Wide Coverage Across Navi Mumbai",
        WhyChoosedescription: "Pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, Sanpada, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a hassle-free travel experience throughout the journey."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Options",
        WhyChoosedescription: "Customers can choose one-way rides, round trips, airport transfers, business travel, sightseeing tours, and customized travel packages."
    },
    {
        WhyChooseheading: "Suitable for Individuals, Families, and Business Travelers",
        WhyChoosedescription: "From solo travelers and small families to corporate professionals and tourists, Swift Dzire offers a practical and comfortable transportation solution."
    }
]
};

const faqData = [
    {
        question: "Why choose Swift Dzire on Rent in Navi Mumbai?",
        answer: "Swift Dzire offers comfortable seating, good luggage space, fuel efficiency, and affordable transportation for local and outstation travel."
    },
    {
        question: "Can I book a Swift Dzire for airport transfers?",
        answer: "Yes, Swift Dzire vehicles are available for Mumbai Airport and Navi Mumbai Airport pickup and drop services."
    },
    {
        question: "Is Swift Dzire available for outstation travel?",
        answer: "Yes, customers can hire Swift Dzire for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Kolhapur, Goa, and many other destinations."
    },
    {
        question: "How many passengers can travel in a Swift Dzire?",
        answer: "Swift Dzire comfortably accommodates up to 4 passengers along with luggage."
    },
    {
        question: "Can corporate clients book Swift Dzire rentals?",
        answer: "Yes, many companies and business professionals use Swift Dzire for meetings, airport transfers, and executive transportation."
    },
    {
        question: "Do you provide chauffeur-driven Swift Dzire rentals?",
        answer: "Yes, all Swift Dzire bookings from Mumbai Airport Cabs include professional and experienced chauffeurs."
    },
    {
        question: "Can I hire Swift Dzire for family trips?",
        answer: "Yes, Swift Dzire is a popular choice for family outings, sightseeing tours, weekend trips, and holiday travel."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Can I schedule a Swift Dzire rental in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel periods."
    },
    {
        question: "How can I book a Swift Dzire on Rent in Navi Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohit Naik",
        feedback:
            "I booked a Swift Dzire for an airport transfer from Navi Mumbai. The cab was clean, comfortable, and the driver arrived exactly on time.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Shah",
        feedback:
            "Our family used a Swift Dzire for a trip to Lonavala. The vehicle was well-maintained, comfortable, and the entire travel experience was smooth and enjoyable.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Navi Mumbai",
  "image": "https://www.mumbaiairportcabs.com/assets/images/swift-dzire-on-rent-navi-mumbai.jpg",
  "description": "Book Swift Dzire on rent in Navi Mumbai for comfortable and budget-friendly travel, airport transfers, and outstation trips. Mumbai Airport Cabs offers reliable Swift Dzire taxi service with professional chauffeurs, clean vehicles, and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "3890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/swift-dzire-on-rent-in-navi-mumbai"
  }
};




    return (
        <div>


<Helmet>
  <title>Swift Dzire on Rent in Navi Mumbai | Budget Cab Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Navi Mumbai for affordable travel, airport transfers, and outstation trips. Comfortable sedan taxi with professional drivers and 24x7 service."
  />

  <meta
    name="keywords"
    content="swift dzire on rent in mumbai, swift dzire on rent in navi mumbai, swift dzire rental navi mumbai, swift dzire hire in navi mumbai, swift dzire car rental navi mumbai, swift dzire taxi service navi mumbai, book swift dzire on rent in navi mumbai, best swift dzire on rent navi mumbai, cheapest swift dzire rental navi mumbai, swift dzire on rent with driver navi mumbai, swift dzire rental service navi mumbai, swift dzire airport pickup navi mumbai, swift dzire airport drop navi mumbai, swift dzire outstation rental navi mumbai, swift dzire cab for outstation navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinnavimumbai;